import * as React from 'react';
import { alpha, styled } from "@mui/material/styles"
import InputBase from '@mui/material/InputBase';
import InputLabel from '@mui/material/InputLabel';
import FormControl from '@mui/material/FormControl';
import MenuItem from '@mui/material/MenuItem';
import Select from '@mui/material/Select';
import { useState } from 'react';
import { useEffect } from 'react';

const CustomInput = styled(InputBase)(({ theme }) => ({
  'label + &': {
    marginTop: theme.spacing(3),
  },
  '&': {
    width: '200px'
  },
  '& .MuiInputBase-input': {
    borderRadius: 4,
    position: 'relative',
    fontSize: "1rem",
    width: '200px',
    transition: theme.transitions.create([
      'border-color',
      'background-color',
      'box-shadow',
    ]),
    padding: "4px 8px",
    margin: 0,
    textAlign: 'left',
    fontFamily: "Open Sans",
  },
  '& .MuiInputBase-input:not([aria-disabled])': {
    backgroundColor: 'var(--background-lightgray)'
  },
  "& .MuiInputBase-input:not([aria-disabled]):focus": {
    borderRadius: 4,
    boxShadow: `${alpha(theme.palette.primary.main, 1)} 0 0 0 0.1rem`,
    borderColor: theme.palette.primary.main,
  },
}));

const SelectFieldDataProfile = ({
  label = "",
  value,
  onChange,
  edit,
  options,
  menuProps,
  sx
}) => {
  const [inputProps, setInputProps] = useState({ readOnly: true })

  useEffect(() => {
    if (edit) {
      setInputProps({ readOnly: false, disabled: false })
    }
    else {
      setInputProps({ readOnly: true, disabled: true })
    }
  }, [edit])

  return (
      <FormControl variant="standard" sx={sx}>
      <InputLabel shrink htmlFor="custom-select" sx={{ fontWeight: "400", color: "var(--grey-inactive)", fontSize: "1.25rem" }}>
        {label}
      </InputLabel>
      <Select
        labelId="custom-select"
        id="custom-select"
        inputProps={inputProps}
        value={value}
        onChange={onChange}
        input={<CustomInput />}
        MenuProps={menuProps}
      >
        {options.map((State) => (
          <MenuItem key={State.name} value={State.name}>{State.name}</MenuItem>
        ))}
      </Select>
    </FormControl>
  )
}

export default SelectFieldDataProfile;